import { cn } from "@peerigon/pupper/tailwind";

type ImageContainerProps = {
	fullTeaser?: boolean;
	isTeaserSection?: boolean;
	className?: string;
	children?: React.ReactNode;
};

export const ImageContainer = ({
	fullTeaser,
	isTeaserSection,
	className,
	children,
}: ImageContainerProps) => (
	<div
		className={cn(
			"z-above-default",
			fullTeaser || isTeaserSection
				? "relative left-0 m-0 h-auto w-full"
				: "absolute right-(--masonry-mobile-image-offset) mt-(--masonry-mobile-image-offset) h-auto w-(--masonry-mobile-image)",
			"md:[&_.full-height-image]:h-full",
			fullTeaser
				? "md:relative md:left-0 md:m-0 md:h-auto md:w-full"
				: "md:absolute md:right-(--masonry-mobile-image-offset) md:left-auto md:mt-(--masonry-mobile-image-offset) md:h-auto md:w-(--masonry-mobile-image)",
			"lg:relative lg:left-0 lg:m-0 lg:overflow-hidden",
			fullTeaser
				? "lg:h-full lg:min-h-(--masonry-full-teaser-min-height) lg:w-full"
				: "lg:h-auto lg:min-h-(--masonry-image-tile) lg:w-auto",
			"lg:[&_.full-height-lg]:h-full",
			className,
		)}
	>
		{children}
	</div>
);
